import React from 'react'
import { Button, Chip, Grid, TextField, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'


// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import SubscriptionServices from '../../../../Services/Consumers/SubscriptionServices'
import { filterData, parseLocaleNumber } from '../../../../utils/helpers'
import {
  exportFiltersPayload,
  UserCompaniesFiltersPayload
} from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import DateFilter from '../../Workspace/PaymentClaimsContent/DateFilter'
import moment from 'moment'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'

let { User_Config } = Configuration
export default function PaymentRequestsContent({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userPaymentRequestsLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  let NumbersRegex = /^[0-9]+$/
  let isFilterValid = {
    request_number: true
  }
  const columns = [
    {
      name: 'request_number',
      label: intl.formatMessage({ id: 'PaymentHeader.requestNumber' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.requestNumber' />:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'PaymentHeader.requestNumber' })}
              id='request_number'
              name='request_number'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.request_number = !(event.target.value && (event.target.value.length !== 20 || !NumbersRegex.test(event.target.value)))
              }}
              helperText={filterList[index][0] &&
                (!NumbersRegex.test(filterList[index][0]) ? intl.formatMessage({ id: 'validationSchema.requestNumberOnlyNumbers' })
                  : ((filterList[index][0]).length !== 20 && intl.formatMessage({ id: 'validationSchema.requestNumberLengthMinMax' })))}
              error={(filterList[index][0] && (!NumbersRegex.test(filterList[index][0]) || (filterList[index][0]).length !== 20))}
            />
          )
        }
      }
    },
    {
      name: 'payable_name',
      label: intl.formatMessage({ id: 'List.Table.PayableName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'payable_description',
      label: intl.formatMessage({ id: 'List.Table.PayableDescription' }),
      options: {
        filter: false,
        display: 'false'
      }
    },
    {
      name: 'payable_type',
      label: intl.formatMessage({ id: 'List.Table.PayableType' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] &&
            <span>{('App\\Models\\Service' === data[dataIndex].payable_type) ?
              intl.formatMessage({ id: 'List.Table.PayableType.Option.Service' })
              : intl.formatMessage({ id: 'List.Table.PayableType.Option.Plan' })}</span>
        }
      }
    },
    {
      name: 'promo_code',
      label: intl.formatMessage({ id: 'List.Table.promo_code' }),
      options: {
        filter: false,
      }
    },
    {
      name: 'original_amount',
      label: intl.formatMessage({ id: 'List.Table.original_amount' }),
      options: {
        filter: false,
        customHeadLabelRender: (columnMeta) => (
          <div className={classes.priceColumnTh}>
            <span>{columnMeta.label}</span>
            <span><FormattedMessage id='Common.beforeDiscount' /></span>
          </div>
        )
      }
    },
    {
      name: 'discount_amount',
      label: intl.formatMessage({ id: 'List.Table.discount_amount' }),
      options: {
        filter: false,
      }
    },
    {
      name: 'price',
      label: intl.formatMessage({ id: 'List.Table.Price' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && (data[dataIndex].price ?
            <div className={classes.priceChipWrapper}>
              <Chip
                icon={<MonetizationOnIcon />}
                label={
                  <div className={classes.priceChip}>
                    <strong><FormattedNumber value={parseLocaleNumber(data[dataIndex].price)} /> <FormattedMessage
                      id='egp' /></strong>
                  </div>
                }
              />
            </div> : '')
        },
        customHeadLabelRender: (columnMeta) => (
          <div className={classes.priceColumnTh}>
            <span>{columnMeta.label}</span>
            <span><FormattedMessage id='Common.afterDiscount' /></span>
          </div>
        ),
      }
    },
    {
      name: 'duration',
      label: intl.formatMessage({ id: 'List.Table.Duration' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && <FormattedMessage id={data[dataIndex].duration ?
            `List.Table.Duration.${data[dataIndex].duration}` : 'List.Table.Duration.null'} />
        }
      }
    },
    {
      name: 'request_state',
      label: intl.formatMessage({ id: 'PaymentHeader.requestState' }),
      options: {
        filterOptions: {
          names: ['pending', 'paid_and_waiting_coretaxation_acknowledgment', 'paid', 'expired', 'failed'],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 'pending':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.pending' })
                break
              case 'paid_and_waiting_coretaxation_acknowledgment':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paidAndWaiting' })
                break
              case 'paid':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paid' })
                break
              case 'expired':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.expired' })
                break
              case 'failed':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.failed' })
                break
              default:
                value = ''
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 'pending':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.pending' })
                break
              case 'paid_and_waiting_coretaxation_acknowledgment':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paidAndWaiting' })
                break
              case 'paid':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paid' })
                break
              case 'expired':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.expired' })
                break
              case 'failed':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.failed' })
                break
              default:
                value = ''
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.requestState' />:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'created_at',
      label: intl.formatMessage({ id: 'PaymentHeader.requestCreatedDate' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].created_at}</Moment>
        }
      }
    },
    {
      name: 'expire_date',
      label: intl.formatMessage({ id: 'PaymentHeader.requestExpireDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].expire_date}</Moment>
        }
      }
    },
    {
      name: 'created_from_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateFrom' />:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_from_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateFrom' })}
            />
          )
        }
      }
    },
    {
      name: 'created_to_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateTo' />:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_to_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateTo' })}
            />
          )
        }
      }
    }
  ]
  // get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        SubscriptionServices.getPaymentRequests({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((request) => {
                newData.push({
                  request_number: request.request_number,
                  payable_name: request.payable.title,
                  payable_description: request.payable.description,
                  payable_type: request.payable_type,
                  price: request.amount,
                  duration: request.priceable.price_duration,
                  request_state: request.request_state,
                  created_at: request.created_at,
                  expire_date: request.expire_date,
                  original_amount: request.original_amount,
                  discount_amount: request.discount_amount,
                  promo_code: request.promo_code,
                })
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
    getUsersListData(1)
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('created_from_datetime' === columns[index].name || 'created_to_datetime' === columns[index].name) {
          filters[columns[index].name] = moment(filterItem[0]).utc().format('DD-MM-YYYY HH:mm:ss')
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
    if (!!currentFilter) {
      xhrRequest(1, {}, true)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      SubscriptionServices.exportPaymentRequests({
        headers: {
          'Authorization': `Bearer ${keycloak?.token ?? ''}`,
          'Accept': 'application/octet-stream'
        },
        params: filterData(exportFiltersPayload(currentFilter)),
        responseType: 'blob'
      }).then((result) => {
        if (result.data) {
          const type = result.headers['content-type']
          const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = result.headers['content-disposition']
          let fileName = `${intl.formatMessage({ id: 'PaymentsContent.ActionLinks.PaymentRequests' })}.xlsx`
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2)
              fileName = fileNameMatch[1]
          }
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      return false
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained"
            disabled={!(isFilterValid.request_number)}
            onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters' /></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && (column === 'created_from_datetime' || column === 'created_to_datetime' || column === 'request_number'))) {
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'PaymentRequests.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'PaymentRequests.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='PaymentsContent.ActionLinks.PaymentRequests' />} />
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true} />}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='PaymentsContent.ActionLinks.PaymentRequests' />
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
